import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { transactionAccountConstant } from "../constants/constants";


class TransactionAccountStore extends EventEmitter {
    constructor() {
        super();
        this.trAccounts = [];
        this.trAccountsPaymentMode = {};
    }

    getAll() {
        return this.trAccounts;
    }
    getAllTrAccPayMode() {
        return this.trAccountsPaymentMode;
    }

    handleAction(action) {
        switch (action.type) {
            case transactionAccountConstant.TRANSACTIONACCOUNT_CREATED: {
                const { trAccount } = action;
                this.trAccounts.push(trAccount);

                this.emit(transactionAccountConstant.TRANSACTIONACCOUNT_CREATED, `Transaction Account created successfully.`);
                this.emit(transactionAccountConstant.TRANSACTIONACCOUNT_STORE_CHANGE);
                break;
            }
            case transactionAccountConstant.TRANSACTIONACCOUNT_CREATION_FAILED: {
                this.emit(transactionAccountConstant.TRANSACTIONACCOUNT_CREATION_FAILED, action.msg);
                break;
            }
            case transactionAccountConstant.FETCHED_ALL_TRANSACTIONACCOUNT: {
                //console.log("inside transactionAccount store fetch all");
                this.trAccounts = action.data;
                this.emit(transactionAccountConstant.TRANSACTIONACCOUNT_STORE_CHANGE);
                break;
            }
            case transactionAccountConstant.FETCHED_ALL_TRANSACTION_PAYMENT: {
                this.trAccountsPaymentMode = action.data;
                this.emit(transactionAccountConstant.TRANSACTIONACCOUNT_STORE_CHANGE);
                break;
            }
            case transactionAccountConstant.TRANSACTIONACCOUNT_FETCH_FAILED: {
                //console.log("inside transactionAccount store fatld");
                this.emit(transactionAccountConstant.TRANSACTIONACCOUNT_FETCH_FAILED, action.msg);
                break;
            }
            default:
                break;
        }
    }
}

const transactionAccountStore = new TransactionAccountStore();
dispatcher.register(transactionAccountStore.handleAction.bind(transactionAccountStore));
//window.mpdStore = mpdStore;
//window.dispatcher = dispatcher;
export default transactionAccountStore;


// WEBPACK FOOTER //
// ./src/jsx/store/transaction-account-store.jsx